var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_1528)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 21,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_1528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5527 9H27.1719V11.2326C29.9007 11.2326 32.6293 11.2381 35.3579 11.2241C35.8187 11.2435 36.3257 11.2102 36.7263 11.492C37.0069 11.905 36.9745 12.4297 36.9934 12.9041C36.9799 17.7487 36.9854 22.5907 36.9882 27.4324C36.9747 28.2446 37.0617 29.0734 36.8955 29.8744C36.7865 30.4549 36.105 30.4687 35.6496 30.4884C32.8256 30.4966 29.9988 30.4828 27.1719 30.4884V33H25.479C21.3246 32.2269 17.162 31.5127 13.0024 30.7674V11.2355C17.1869 10.4902 21.3711 9.75639 25.5527 9Z",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1713 12.0698H36.1669V29.6512H27.1713V27.9768H29.352V26.0233H27.1713V24.907H29.352V22.9535H27.1713V21.8373H29.352V19.8838H27.1713V18.7675H29.352V16.814H27.1713V15.6977H29.352V13.7442H27.1713V12.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4424 13.7441H34.2588V15.6976H30.4424V13.7441Z",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.076 16.3589C21.6921 16.3143 22.311 16.2752 22.9297 16.2446C22.203 17.7725 21.4697 19.2972 20.73 20.8185C21.4797 22.3813 22.2454 23.9329 22.9977 25.4957C22.3415 25.4571 21.6855 25.4143 21.0298 25.3673C20.5664 24.2035 20.002 23.0789 19.6695 21.8622C19.2989 22.9952 18.7699 24.0639 18.3449 25.1749C17.7478 25.1664 17.1507 25.1414 16.5538 25.1161C17.2543 23.7125 17.9303 22.2975 18.6526 20.9022C18.0393 19.4649 17.3659 18.0557 16.7335 16.6268C17.3332 16.5905 17.9329 16.5543 18.5326 16.5208C18.9387 17.6121 19.3829 18.6891 19.7185 19.8082C20.0781 18.6223 20.6152 17.506 21.076 16.3589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4424 16.814H34.2588V18.7675H30.4424V16.814ZM30.4424 19.8837H34.2588V21.8372H30.4424V19.8837ZM30.4424 22.9535H34.2588V24.907H30.4424V22.9535ZM30.4424 26.0233H34.2588V27.9768H30.4424V26.0233Z",
    fill: "#207245"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_1528",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_1528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_1528",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_1528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.1ae0ac0772226671f9ce939fb3fe052f.svg";
export { ForwardRef as ReactComponent };